import React from 'react'
import Nav from '../Header'

const MainHeader = () => {
  return <Nav />
}

export default MainHeader
